import React, { useEffect, useState } from 'react';
import Navbar from "./Components/Navbar";
import Access from "./Components/Access";
import BounceLoader from "react-spinners/BounceLoader";
import axios from 'axios';
import qs from 'qs';
import { addSpace, capitalizeFirstLetter } from './Components/Tools';
import {NotificationManager} from 'react-notifications';

const Restitution = (props) =>
{
    const heightObject = window.innerHeight/1.5;
    const [objet, setObjet] = useState([]);
    const [annees, setAnnees] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    let retroprosp = window.location.pathname.split('/')[2];
    let fctinv = window.location.pathname.split('/')[3];
    

    const purple = '#6571FE';
    const blue = '#069BD3';


    async function validation(datas_tmp, hyp)
    {
        var ret = true
        var tmpi = 0
        var tab_tmp = {}
        while(tmpi <= datas_tmp.length / 10)
        {
            tab_tmp[tmpi] = datas_tmp.slice(0 + (tmpi * 10), 10 + (tmpi * 10))
            const params = {
                'update': true,
                'hypothese': hyp,
                'id_budget': props.user.id_budget,
                'fctinv': fctinv,
                'grille': tab_tmp[tmpi]
            }
            
            await axios.post("https://app-slfinance.fr/api/datas_restitution.php", qs.stringify(params))
            .catch((err) => {
                ret = false
                console.warn(err)
            })
            tmpi++;
        }
        return ret;
    }


    async function mount()
    {
        // Initialisation des variables
        let hyp = null;
        let grille_temporaire = '';
        const nomen = props.user.nomen;
        const orgType = props.user.id_organisme_type;
        let retro_an_deb = parseInt(props.user.config_budget.retro_an_deb);
        let retro_an_fin = parseInt(props.user.config_budget.retro_an_fin);
        let prosp_an_fin = parseInt(props.user.config_budget.prosp_an_fin);

        if (isNaN(retro_an_deb) || isNaN(retro_an_fin) || isNaN(prosp_an_fin)) {
            // recuperation des années dans la table application
            await axios.post('https://app-slfinance.fr/api/application.php', qs.stringify({
                get: true
            }))
            .then((res) => {
                if (res.data && res.data.retro_an_deb && res.data.retro_an_fin && res.data.prosp_an_fin) {
                    const config = res.data;
                    retro_an_deb = parseInt(config.retro_an_deb);
                    retro_an_fin = parseInt(config.retro_an_fin);
                    prosp_an_fin = parseInt(config.prosp_an_fin);
                }
                else {
                    NotificationManager.error("Veuillez renseigner les années de retrospective et de prospective", '', 5000);
                    return;
                }
            })
            .catch(() => {
                NotificationManager.error("Erreur lors de la récupération de la configuration des années", '', 5000);
            });
        }

        // Détermination de la grille et de l'hypothèse
        if (orgType === '4')
        {
            // EPFL
            if (retroprosp === 'retrospective') {
            hyp = 'R';
            grille_temporaire = fctinv === 'fct' ? 'EpflRetroExploit' : 'EpflRetroInv';
            } else {
            hyp = 'h' + props.user.hypothese;
            grille_temporaire = fctinv === 'fct' ? 'EpflProspExploit' : 'EpflProspInv';
            }
        } else if (['M14', 'M57'].includes(nomen)) {
            // M14 ou M57
            hyp = retroprosp === 'retrospective' ? 'R' : 'h' + props.user.hypothese;

            if (fctinv === 'fct') {
            grille_temporaire = ['1', '3'].includes(orgType) ? 'ComFct' : orgType === '2' ? 'EpciFct' : '';
            } else if (['inv', 'fiscalite'].includes(fctinv)) {
            grille_temporaire = retroprosp === 'retrospective' ? 'Retro' : 'Prosp';
            grille_temporaire += fctinv === 'inv' ? 'Inv' : 'Fiscalite';
            }
        } else if (['M4', 'M41', 'M43', 'M49'].includes(nomen)) {
            // M4, M41, M43, M49
            grille_temporaire = nomen;
            grille_temporaire += retroprosp === 'retrospective' ? 'Retro' : 'Prosp';
            grille_temporaire += fctinv === 'fct' ? 'Fct' : fctinv === 'inv' ? 'Inv' : '';
        }

        // Construction de la liste des années
        let liste_an = [];
        if (retroprosp === 'retrospective') {
            for (let an = retro_an_deb; an <= retro_an_fin; an++) {
            liste_an.push(an);
            }
        } else {
            for (let an = retro_an_fin; an <= prosp_an_fin; an++) {
            liste_an.push(an);
            }
        }
        await setAnnees(liste_an);

        
        // Condition temporaire pour le nouveau backend et les nouvelles grilles de restitution
        if (props.user.id_organisme_type === '1' && retroprosp === 'retrospective' && fctinv === 'fct') {
            grille_temporaire = 'ComRetroFct';
        }
        else if (props.user.id_organisme_type === '1' && retroprosp === 'prospective' && fctinv === 'fct') {
            grille_temporaire = 'ComProspFct';
        }
        else if (props.user.id_organisme_type === '1' && retroprosp === 'retrospective' && fctinv === 'inv') {
            grille_temporaire = 'ComRetroInv';
        }
        else if (props.user.id_organisme_type === '1' && retroprosp === 'prospective' && fctinv === 'inv') {
            grille_temporaire = 'ComProspInv';
        }
        if (props.user.id_organisme_type === '2' && retroprosp === 'retrospective' && fctinv === 'fct') {
            grille_temporaire = 'EpciRetroFct';
        }
        if (props.user.id_organisme_type === '2' && retroprosp === 'prospective' && fctinv === 'fct') {
            grille_temporaire = 'EpciProspFct';
        }
        if (props.user.id_organisme_type === '2' && retroprosp === 'retrospective' && fctinv === 'inv') {
            grille_temporaire = 'EpciRetroInv';
        }
        if (props.user.id_organisme_type === '2' && retroprosp === 'prospective' && fctinv === 'inv') {
            grille_temporaire = 'EpciProspInv';
        }


        // Préparation des variables pour la requête
        const formvars = {
            getRestitution: true,
            grille: grille_temporaire,
            annees: liste_an,
            id_budget: props.user.id_budget,
            id_organisme: props.user.id_organisme,
            nomen: props.user.nomen,
            hypothese: retroprosp === 'retrospective' ? 'R' : 'H' + props.user.hypothese
        };
        
        setIsSaving(true);
        await axios.post('https://app-slfinance.fr/api/restitution.php', qs.stringify(formvars))
        .then(async(ret) => {
            if (ret.data.length != 0) {
                await setObjet(ret.data);
                await validation(ret.data, formvars.hypothese)
                .then(() => {
                    NotificationManager.success("Grille sauvegardée", '', 700);
                    setIsSaving(false);
                })
            }
            else {
                NotificationManager.warning("Absence de données", '', 3000);
                setIsSaving(false);
            }
        })
        .catch(() => {
            NotificationManager.error("Erreur lors de la récupération des données de restitution", '', 5000);
            setIsSaving(false);
        })
    }


    // Récuperation de la liste des fiches projets
    useEffect(() => {
        if (props.user === null) {
            props.getUser()
        }
        else {
            mount();
        }
        
    }, [props.user])

    
	return (
        <div>
            <Access needConnection={true} type_user={[0]}>
                <Navbar user={props.user} />
                <div style={{display: 'flex'}}>
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <p>Restitution</p>
                        <p style={{marginLeft: 5}}>\</p>
                        <p style={{marginLeft: 5}}>{capitalizeFirstLetter(retroprosp)}</p>
                        <p style={{marginLeft: 5}}>\</p>
                        <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>{fctinv === 'fct'?props.user && props.user.id_organisme_type === '4'?'Exploitation':'Fonctionnement':fctinv === 'fiscalite'?'Fiscalité':'Investissement'}</p>
                    </div>
                    
                    <div style={{flex: 0.5, margin: 20, display: 'flex', textAlign: 'center', justifyContent: 'center', alignItems: 'center', gap: 5}}>
                    {props.user?
                        <p style={{margin: 0}}>{props.user.nom_budget}</p>
                    :null}
                    </div>
                    
                    <div style={{flex: 1, margin: 20, display: 'flex', left: 0, justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
                        {isSaving && objet.length !== 0 && (
                            <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                <BounceLoader color={'#6571FE'} size={20} />
                                <span style={{fontSize: 12, color: '#666'}}>En cours de sauvegarde...</span>
                            </div>
                        )}
                    </div>
                    
                </div>
                {/* Grille Restitution */}
                {objet.length != 0?
                <div className='shadow-xl rounded-md' style={{margin: 20}}>
                    
                    {/* Premiere ligne "Montants en €" suivi des années*/}
                    <div style={{display: 'flex', textAlign: 'center'}}>
                        <div style={{flex: 3, padding: 3, backgroundColor: blue, textAlign: 'center'}}>
                            <p style={{color: 'white', fontSize: 20}}>Montants en €</p>
                        </div>

                        {annees.map((an, j) =>
                        <div key={j} style={{flex: 1, display: 'flex'}}>
                            <div style={{flex: 1, padding: 3, backgroundColor: blue, borderLeft: '1px solid white', color: 'white', fontSize: 18}}>
                                <p>{an}</p>
                            </div>
                        </div>
                        )}
                    </div>


                    
                    {/* Liste de la grille avec les données */}
                    <div>
                        {objet && objet.length > 0 &&
                        objet.filter(line =>
                            fctinv !== 'fiscalite' ||
                            line.slice(1).some(an => an[1] !== 0 && an[1] !== null && an[1] !== undefined && an[1] !== '' && an[1] !== '0')
                        ).map((line, i) =>
                        <div key={i} style={{borderTop: '1px solid white'}}>
                            <div style={{display: 'flex'}}>
                                <div style={
                                    line[0].chapitre === '1'?
                                        {flex: 3, display: 'flex', padding: 3, backgroundColor: blue}
                                    :
                                        line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120' || line[0].matricule === 'ComProspInv70' || line[0].matricule === 'ComProspInv75' || line[0].matricule === 'ComProspInv120'?
                                            {flex: 3, display: 'flex', padding: 3, color: blue, fontWeight: 'bold'}
                                        :
                                            line[0].indentation === '1'?
                                                {flex: 3, display: 'flex', padding: 3}
                                            :
                                                {flex: 3, display: 'flex', padding: 3, fontSize: 14, fontStyle: 'italic'}
                                    }>
                                    <p style={
                                        line[0].indentation === '1'?
                                            line[0].chapitre === '1'?
                                                {color: 'white'}
                                            :
                                                {}
                                        :
                                            {marginLeft: 50}
                                    }>{line[0].intitule}</p>
                                </div>
                                {line.map((an, j) =>
                                j !== 0?
                                <div key={j} style={{flex: 1, display: 'flex'}}>
                                    <div style={
                                        line[0].chapitre === '1'?
                                            {flex: 1, padding: 3, backgroundColor: blue, borderLeft: '1px solid white', color: 'white', textAlign: 'right'}
                                        :
                                            line[0].matricule === 'ComRetroInv70' || line[0].matricule === 'ComRetroInv75' || line[0].matricule === 'ComRetroInv120' || line[0].matricule === 'ComProspInv70' || line[0].matricule === 'ComProspInv75' || line[0].matricule === 'ComProspInv120'?
                                                {flex: 1, padding: 3, borderLeft: '1px solid white', textAlign: 'right', color: blue, fontWeight: 'bold'}
                                            :
                                                line[0].indentation === '1'?
                                                    {flex: 1, padding: 3, borderLeft: '1px solid white', textAlign: 'right'}
                                                :
                                                    {flex: 1, padding: 3, borderLeft: '1px solid white', textAlign: 'right', fontSize: 13, fontStyle: 'italic'}
                                        }>
                                        {( line[0]['matricule'] === 'ComRetroInv140'
                                        || line[0]['matricule'] === 'ComProspInv140'
                                        || line[0]['matricule'] === 'M4RetroInv130'
                                        || line[0]['matricule'] === 'M4ProspInv115'
                                        || line[0]['matricule'] === 'M41RetroInv130'
                                        || line[0]['matricule'] === 'M41ProspInv115'
                                        || line[0]['matricule'] === 'M43RetroInv130'
                                        || line[0]['matricule'] === 'M43ProspInv115'
                                        || line[0]['matricule'] === 'M49RetroInv130'
                                        || line[0]['matricule'] === 'M49ProspInv115')
                                        &&
                                        <p>{an[1] === 0?null:addSpace(Math.round(an[1]*100)/100, true)} an(s)</p>
                                        }

                                        {( line[0]['matricule'] === 'ComRetroInv145'
                                        || line[0]['matricule'] === 'ComRetroInv150'

                                        || line[0]['matricule'] === 'ComProspInv145'
                                        || line[0]['matricule'] === 'ComProspInv150'

                                        || line[0]['matricule'] === 'M4RetroInv140'
                                        || line[0]['matricule'] === 'M4ProspInv125'

                                        || line[0]['matricule'] === 'M41RetroInv140'
                                        || line[0]['matricule'] === 'M41ProspInv125'
                                        
                                        || line[0]['matricule'] === 'M43RetroInv140'
                                        || line[0]['matricule'] === 'M43ProspInv125'
                                        
                                        || line[0]['matricule'] === 'M49RetroInv140'
                                        || line[0]['matricule'] === 'M49ProspInv125'

                                        || line[0]['matricule'] === 'EpflRetroInv135'
                                        || line[0]['matricule'] === 'EpflRetroInv140'
                                        || line[0]['matricule'] === 'EpflRetroInv145'
                                        
                                        || line[0]['matricule'] === 'EpflProspInv135'
                                        || line[0]['matricule'] === 'EpflProspInv140'
                                        || line[0]['matricule'] === 'EpflProspInv145'
                                        
                                        || line[0]['matricule'] === 'M4RetroInv135'
                                        || line[0]['matricule'] === 'M4ProspInv120'
                                        
                                        || line[0]['matricule'] === 'M41RetroInv135'
                                        || line[0]['matricule'] === 'M41ProspInv120'
                                        
                                        || line[0]['matricule'] === 'M43RetroInv135'
                                        || line[0]['matricule'] === 'M43ProspInv120'
                                        
                                        || line[0]['matricule'] === 'M49RetroInv135'
                                        || line[0]['matricule'] === 'M49ProspInv120'
                                        )
                                        &&
                                        <p>{an[1] === 0?null:addSpace(Math.round(an[1]*100)/100)}%</p>
                                        }

                                        {( line[0]['matricule'] === 'ComRetroInv155'
                                        || line[0]['matricule'] === 'ComProspInv155'
                                        || line[0]['matricule'] === 'M4RetroInv145'
                                        || line[0]['matricule'] === 'M4ProspInv130'
                                        || line[0]['matricule'] === 'M41RetroInv145'
                                        || line[0]['matricule'] === 'M41ProspInv130'
                                        || line[0]['matricule'] === 'M43RetroInv145'
                                        || line[0]['matricule'] === 'M43ProspInv130'
                                        || line[0]['matricule'] === 'M49RetroInv145'
                                        || line[0]['matricule'] === 'M49ProspInv130')
                                        &&
                                        <p>{an[1] === 0?null:addSpace(Math.round(an[1]), true)} jour(s)</p>
                                        }

                                        {/* Toutes les cellules */}
                                        {  line[0]['matricule'] !== 'ComRetroInv140'
                                        && line[0]['matricule'] !== 'ComRetroInv145'
                                        && line[0]['matricule'] !== 'ComRetroInv150'
                                        && line[0]['matricule'] !== 'ComRetroInv155'

                                        && line[0]['matricule'] !== 'ComProspInv140'
                                        && line[0]['matricule'] !== 'ComProspInv145'
                                        && line[0]['matricule'] !== 'ComProspInv150'
                                        && line[0]['matricule'] !== 'ComProspInv155'

                                        && line[0]['matricule'] !== 'M4RetroInv130'
                                        && line[0]['matricule'] !== 'M4RetroInv135'
                                        && line[0]['matricule'] !== 'M4RetroInv140'
                                        && line[0]['matricule'] !== 'M4RetroInv145'

                                        && line[0]['matricule'] !== 'M4ProspInv115'
                                        && line[0]['matricule'] !== 'M4ProspInv120'
                                        && line[0]['matricule'] !== 'M4ProspInv125'
                                        && line[0]['matricule'] !== 'M4ProspInv130'

                                        && line[0]['matricule'] !== 'M41RetroInv130'
                                        && line[0]['matricule'] !== 'M41RetroInv135'
                                        && line[0]['matricule'] !== 'M41RetroInv140'
                                        && line[0]['matricule'] !== 'M41RetroInv145'

                                        && line[0]['matricule'] !== 'M41ProspInv115'
                                        && line[0]['matricule'] !== 'M41ProspInv120'
                                        && line[0]['matricule'] !== 'M41ProspInv125'
                                        && line[0]['matricule'] !== 'M41ProspInv130'

                                        && line[0]['matricule'] !== 'M43RetroInv130'
                                        && line[0]['matricule'] !== 'M43RetroInv135'
                                        && line[0]['matricule'] !== 'M43RetroInv140'
                                        && line[0]['matricule'] !== 'M43RetroInv145'

                                        && line[0]['matricule'] !== 'M43ProspInv115'
                                        && line[0]['matricule'] !== 'M43ProspInv120'
                                        && line[0]['matricule'] !== 'M43ProspInv125'
                                        && line[0]['matricule'] !== 'M43ProspInv130'

                                        && line[0]['matricule'] !== 'M49RetroInv130'
                                        && line[0]['matricule'] !== 'M49RetroInv135'
                                        && line[0]['matricule'] !== 'M49RetroInv140'
                                        && line[0]['matricule'] !== 'M49RetroInv145'

                                        && line[0]['matricule'] !== 'M49ProspInv115'
                                        && line[0]['matricule'] !== 'M49ProspInv120'
                                        && line[0]['matricule'] !== 'M49ProspInv125'
                                        && line[0]['matricule'] !== 'M49ProspInv130'

                                        && line[0]['matricule'] !== 'EpflRetroInv135'
                                        && line[0]['matricule'] !== 'EpflRetroInv140'
                                        && line[0]['matricule'] !== 'EpflRetroInv145'

                                        && line[0]['matricule'] !== 'EpflProspInv135'
                                        && line[0]['matricule'] !== 'EpflProspInv140'
                                        && line[0]['matricule'] !== 'EpflProspInv145'
                                        &&
                                        <p>{an[1] == 0?null:addSpace(Math.round(an[1]), true)}</p>
                                        }

                                    </div>
                                </div>
                                :null)}
                            </div>
                        </div>
                        )}

                    </div>

                </div>
                :
                <div style={{flex: 1, margin: 100, display: 'flex'}}>
                    <div style={{flex: 1}}></div>
                    <BounceLoader color={purple} />
                    <div style={{flex: 1}}></div>
                </div>}
                <div style={{height: 50}}></div>
            </Access>
        </div>
	);
}

export default Restitution;
